/*

--------------------------------------------------------------------------------
Custom password widget using some Kendo-style functionality.
Provides password with placeholder also for browsers which don't support it,
validation and tooltip popup icons and applying similar component status behavior
as in native Kendo UI widgets.
When the browser doesn't support placeholders, there is a separate label generated
under the main input, which is shown only when the main input is empty. Same
.placeholder CSS class is applied as for other widgets, so styling should be
reasonably easy.
For base functionality see ori.kendo.textbox.js.
For tooltips and validation implementation see ori.kendo.tooltip.js
and ori.kendo.validator.js.
--------------------------------------------------------------------------------

<![CDATA[

*/
; (function ($) {

    "use strict";

    var kendo = window.kendo,
        ui = kendo.ui,
        TextBox = ui.TextBox,
        INPUT = "k-input",
        AVATAR = "avatar",
        NS = ".kendoPassword",
        PASS_TOGGLE_EVENT = 'click',
        ICON_VISIBLE = 'v-icon-eye-with-line',
        ICON_HIDDEN = 'v-icon-eye';

    var Password = TextBox.extend({

        init: function (element, options) {
            var self = this;
            self.ns = self.ns || NS;
            TextBox.fn.init.call(self, element, options);
            self.element.attr("role", "textbox");
            kendo.notify(self);
        },

        options: {
            name: "Password",
            toggleTitleFallback: "Click here for toggle password visibility"
        },

        _wrapper: function () {
            var self = this,
                $element = self.element,
                DOMelement = $element[0],
                $wrapper = $element.parent();
            $element.removeClass(AVATAR);
            if (!$wrapper.is("span.k-widget"))
                $wrapper = $element.wrap("<span />").parent();
            // aria
            $wrapper
                .attr("tabindex", -1)
                .attr("role", "presentation");
            // styling
            $wrapper[0].style.cssText = DOMelement.style.cssText;
            self.wrapper = $wrapper
                .addClass("k-widget k-password k-header")
                .addClass(DOMelement.className)
                .removeClass(INPUT);

            // add the password visibility toggle inside the password input
            togglePasswordVisibility.bind(self)();
        }
    });

    function togglePasswordVisibility() {
        // self.eventString can not be used because the namespace is no ORI; it is ".kendoPassword"
        // pointerdown event doesn't work in iOS Safari, simple click works perfectly, no fancy logic needed.
        var events = PASS_TOGGLE_EVENT + this.ns;

        $('<a />')
            .attr({
                type: 'button',
                role: 'button',
                title: this.options.toggleTitle || this.options.toggleTitleFallback
            })
            .addClass('pass-visibility-toggle v-icon-eye')
            .on(events, handleTogglePasswordVisibility.bind(this.element[0]))
            .appendTo(this.wrapper);
    }

    function handleTogglePasswordVisibility(e) {
        e.preventDefault();
        this.type = (this.type === 'password' ? 'text' : 'password');
        $(e.target).toggleClass(ICON_VISIBLE, this.type == 'text').toggleClass(ICON_HIDDEN, this.type == 'password');
    }

    ui.plugin(Password);

})(window.kendo.jQuery);

/* ]]> */